import { api } from "./client";

export interface NotificationRead {
  id: string;
  kind: string;
  title: string;
  body: string | null;
  link: string | null;
  is_read: boolean;
  read_at: string | null;
  created_at: string;
}

export interface NotificationList {
  items: NotificationRead[];
  total: number;
  unread: number;
}

export async function listNotifications(
  unread_only = false,
  limit = 50,
): Promise<NotificationList> {
  const { data } = await api.get<NotificationList>("/notifications", {
    params: { unread_only, limit },
  });
  return data;
}

export async function markNotificationRead(id: string): Promise<NotificationRead> {
  const { data } = await api.post<NotificationRead>(`/notifications/${id}/read`);
  return data;
}

export async function markAllNotificationsRead(): Promise<void> {
  await api.post("/notifications/read-all");
}
